import { isMultiTenant } from "@/Configs/config";
import { useSelectedSite } from "@/api/hooks/useSelectedSite";
import { Card, CardComponentVariant } from "@/components/pageCards/card";
import { useTrans } from "@/translations";

import { FC, useMemo } from "react";
import { Link } from "react-router-dom";

export interface CustomerPrefilteringCardProps {
  customerId: string;
}

export const CustomerPrefilteringCard: FC<CustomerPrefilteringCardProps> = ({
  customerId,
}) => {
  const { t } = useTrans();
  const { selectedSite } = useSelectedSite();

  const eventsPathName = useMemo(() => {
    let pathSite = "";

    if (isMultiTenant && selectedSite?.siteName) {
      pathSite = `/${selectedSite.siteName}`;
    }

    return `${pathSite}/events`;
  }, [selectedSite]);

  return (
    <Card
      title={"drawerLabels:preFiltering"}
      variant={CardComponentVariant.DRAWER}
    >
      <p className="text black font-dm-sans mb-4 text-sm">
        {t("hints:goToPrefilteredEvents")}
      </p>
      <div className="flex items-center">
        <Link
          to={{
            pathname: eventsPathName,
            search: `?filters=${encodeURIComponent(JSON.stringify({ customerId }))}`,
          }}
          className="font-dm-sans pr-9 text-base font-medium underline"
        >
          {t("actions:seeTheEvents")}
        </Link>
        <p className="font-dm-sans text-sm text-black">
          {t("hints:tenantsLatestEvents")}
        </p>
      </div>
    </Card>
  );
};
